import { useCallback, useRef } from 'react';

import {
  isValidFileSize,
  ACCEPTED_FILES,
} from '@xing-com/crate-articles-image-cropper-modal';
import { IconImage } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ImageToolProps } from '../types';

export const ImageTool: React.FC<ImageToolProps> = ({
  editor,
  disabled,
  onImageUpload,
}) => {
  const inputFileRef = useRef<HTMLInputElement | null>(null);

  const handleImageUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!editor || !e.target.files?.length) {
        return;
      }

      const image = e.target.files.item(0) as File;
      if (isValidFileSize(image)) {
        onImageUpload?.(image, (_: string, imageURL: string) => {
          editor
            .chain()
            .focus()
            .addXingImage(imageURL)
            .createParagraphNear()
            .run();
        });
      }

      e.target.value = '';
    },
    [editor, onImageUpload]
  );

  return (
    <div>
      <Styled.ToolBarButton
        onClick={() => {
          inputFileRef.current?.click?.();
        }}
        disabled={disabled}
      >
        <IconImage width={24} height={24} />
      </Styled.ToolBarButton>
      <input
        ref={inputFileRef}
        data-qa="articles-image-tool-input"
        data-testid="articles-image-tool-input"
        type="file"
        accept={ACCEPTED_FILES}
        onChange={handleImageUpload}
        hidden
      />
    </div>
  );
};
